<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-row>

        <d-col md="6" class="form-group">
          <d-form>
            <dynamic-list
              :list="rolesList"
              label="usuários"
              :show-save="true"
              :on-add="addRow"
              :on-remove="removeRow"
              :on-save="saveRoles"
              :on-change="capitalizeInput"
            />
          </d-form>
        </d-col>

      </d-row>

    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import { stringfy, capitalize } from '_utils/string';
import AccessControlService from '_services/rest/modules/accessControl';
import formatErrors from '_common/mixins/FormatErrors';
import DynamicList from '../DynamicList.vue';
import { OPTION } from '../SettingsModel';

export default {
  name: 'roles-form',
  mixins: [formatErrors],
  components: {
    DynamicList,
  },
  data() {
    return {
    };
  },
  computed: {
    rolesList() {
      const { roles } = this.$store.state.settings;
      if (roles && roles.length > 0) {
        return roles;
      }
      return [{ ...OPTION }];
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getRoles',
      'addRole',
    ]),
    addRow() {
      return this.addRole({ ...OPTION });
    },
    capitalizeInput(index) {
      this.rolesList[index].name = capitalize(this.rolesList[index].name);
    },
    checkEmptyOptions() {
      if (this.rolesList.length === 0) {
        this.rolesList.push({ ...OPTION });
      }
    },
    formatSlug(option) {
      option.slug = stringfy(option.name);
    },
    getOptions() {
      this.getRoles();
    },
    removeRow(index) {
      AccessControlService.removeRoles(this.rolesList[index].id)
        .then(() => {
          this.rolesList.splice(index, 1);
          this.checkEmptyOptions();
          this.activeAlert({ message: 'Departamento salvas com sucesso', theme: 'success' });
        })
        .catch(this.showError)
        .finally(this.loading = false);
    },
    saveRoles(index) {
      this.formatSlug(this.rolesList[index]);
      AccessControlService.saveRoles(this.rolesList[index])
        .then(() => {
          this.activeAlert({ message: 'Departamento salvas com sucesso', theme: 'success' });
          this.getRoles();
        })
        .catch(this.showError);
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';
</style>
